// removed by extract-text-webpack-plugin
module.exports = {"tabs":"_3QVKweqdzkJJbfSuPOzwbI"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/AuthenticationContainer/AuthTabList/AuthTabList.scss
// module id = 1808
// module chunks = 0